module.exports = __webpack_public_path__ + "00_cheek.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer2/00_cheek.png
// module id = /3d2
// module chunks = 0